import axios from "axios";

import { environment } from "../environments/environment";

 

 

const apiService = axios.create({

  baseURL: `${environment.apiEndPoint}`,

});

 

apiService.interceptors.request.use(

  async (config) => {

    console.log(`${environment.apiEndPoint}`);

    config.headers["Access-Control-Allow-Origin"] = "*";

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);

 

// Function to make a GET request

export const getData = (url: string, params = {}) => {

  return apiService.get(url, {

    params: params,

  });

};

 


 